import { InspectionInterface } from '../interfaces/inspection';
import { Pa } from "./pa";
import { User } from "./user";
import { InspectionState } from "./inspectionState";
import { Contract } from "./contract";

export class Inspection implements InspectionInterface {
    id_inspection?: number;
    fk_id_pa: number;
    pa: Pa;
    fk_id_user?: number | null;
    user: User;
    fk_id_inspection_state: number;
    inspection_state?: InspectionState;
    fk_id_contract: number;
    contract: Contract;
    date?: Date | null;
    date_inspection?: Date | null;
    date_validation?: Date | null;
    furniture_order?: string;
    referent_name?: string | null;
    referent_surname?: string | null;
    referent_function?: string | null;
    inspector_name?: string | null;
    inspector_surname?: string | null;
    start_hour?: string | null;
    end_hour?: string | null;

    constructor() {
        this.fk_id_pa = 0;
        this.pa = new Pa();
        this.fk_id_user = undefined;
        this.user = new User();
        this.fk_id_inspection_state = 0;
        this.inspection_state = new InspectionState();
        this.fk_id_contract = 0;
        this.contract = new Contract();
        this.date = undefined;
        this.date_inspection = undefined;
        this.date_validation = undefined;
        this.furniture_order = '';
        this.referent_name = '';
        this.referent_surname = '';
        this.referent_function = '';
        this.inspector_name = '';
        this.inspector_surname = '';
        this.start_hour = undefined;
        this.end_hour = undefined;
    }
}
